import { ContainerLoading } from "./container-loading";
import { ContainerNoData } from "./container-no-data";
import { ContainerIsShow } from "./container-is-show";
 
export const ContentConditional = {
  Loading: ContainerLoading,
  NoData: ContainerNoData,
  IsShow: ContainerIsShow,
 };
